<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReservationsBedInTwinIndex'
}
</script>
